import { useContext, useEffect } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

let _bypass = false;

export function navigationBypass(fn: () => void) {
  _bypass = true;
  try {
    fn();
  } finally {
    _bypass = false;
  }
}

export default function usePreventNavigation(
  shouldPrevent: boolean,
  message: string
) {
  const { navigator } = useContext(NavigationContext);

  useEffect(() => {
    if (!shouldPrevent) return;

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [shouldPrevent]);

  useEffect(() => {
    if (!shouldPrevent) return;

    const push = navigator.push;
    const go = navigator.go;

    navigator.push = (...args) => {
      if (_bypass) return push.apply(navigator, args);
      const allow = globalThis.confirm(message);
      if (allow) push.apply(navigator, args);
    };

    navigator.go = (...args) => {
      if (_bypass) return go.apply(navigator, args);
      const allow = globalThis.confirm(message);
      if (allow) go.apply(navigator, args);
    };

    return () => {
      navigator.push = push;
      navigator.go = go;
    };
  }, [shouldPrevent, navigator, message]);
}
